import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {PageConfig} from 'shells/scheduler/types';

import type {
    GetSchedulerPageConfig as GetSchedulerPageConfigQuery,
    GetSchedulerPageConfigVariables as GetSchedulerPageConfigVariables,
} from 'nutshell-graphql-types';

import {createSubdomainOption} from '../../../setup/domains/helpers';

import GET_SCHEDULER_PAGE_CONFIG from '../queries/get-scheduler-page-config.graphql';

export const useGetSchedulerPageConfig = (
    userId: string
): {
    schedulerPageConfig: PageConfig | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetSchedulerPageConfigQuery,
        GetSchedulerPageConfigVariables
    >(GET_SCHEDULER_PAGE_CONFIG, {
        variables: {
            userId,
        },
    });

    const schedulerPageConfig = data ? data.schedulerPageConfig : null;

    const pageConfig: PageConfig | null | undefined = schedulerPageConfig
        ? {
              useAvatar: schedulerPageConfig.useAvatar,
              useCompanyLogo: schedulerPageConfig.useCompanyLogo,
              userSlug: schedulerPageConfig.userSlug || schedulerPageConfig.defaultUserSlug,
              defaultUserSlug: schedulerPageConfig.defaultUserSlug,
              domain: createSubdomainOption(
                  schedulerPageConfig.fromDomain || schedulerPageConfig.defaultFromDomain
              ),
              embedSnippet: schedulerPageConfig.embedSnippet,
          }
        : null;

    return {
        schedulerPageConfig: pageConfig,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
